
import { useState, useEffect } from "react";

const CheckboxFilter = ({ field, label, filters, defaultValue = true, setFilter, addFilter }) => {
    const [defaultValueState, setDefaultValueState] = useState(true);
    let allReadySet = filters.filter(function (e) { return e.field === field; });

    useEffect(() => {
        let allReadySet = filters.filter(function (e) { return e.field === field; });
        if (allReadySet.length > 0) {
            setDefaultValueState(allReadySet[0].values[0]);
        }
    
      }, [filters])
   

    const handleChange = (e) => {
        allReadySet.length > 0 ? setFilter(field, e.target.checked) : addFilter(field, e.target.checked)
    }

    return (
        <div>
            <input type="checkbox" id={field} name={field}  checked={defaultValueState}
                onChange={(e) => {
                    handleChange(e)
                }} />
            <label htmlFor={field}> {label}</label>
        </div>
      
    )
}

export default CheckboxFilter;